import { CURRENCIES, formatCurrency, getCurrencyConfig } from '../config/currencies';
import { MARKET_CURRENCY } from '../config/markets';
import type { UseUserCurrencyReturn } from './useGlobalUserCurrency';

const formatPrice = (amount: number) => formatCurrency(amount, MARKET_CURRENCY);
const keepCurrency = (_code: string) => {};
const getCurrencySymbol = (code: string) => getCurrencyConfig(code)?.symbol || code;

/** New Saudi prices use SAR; explicit stored currencies are never relabeled. */
export function useUserCurrency(): UseUserCurrencyReturn {
  return {
    currency: MARKET_CURRENCY,
    currencyConfig: getCurrencyConfig(MARKET_CURRENCY),
    setCurrency: keepCurrency,
    formatPrice,
    formatPriceWithCurrency: formatCurrency,
    getCurrencySymbol,
    isAutoDetected: false,
    isLoading: false,
    detectedCountry: undefined,
    detectedCountryName: undefined,
    availableCurrencies: { [MARKET_CURRENCY]: CURRENCIES[MARKET_CURRENCY] }
  };
}

export default useUserCurrency;
